
import type {
  AddProfileFieldReq,
  BaseErrorResponse,
  EmptySuccessResponse,
  GetProfileFieldRes,
  GetProfileFieldsRes,
  UpdateProfileFieldReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useProfileField() {
  class ProfileField<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Profile fields
     * @name ProfileFieldControllerGetProfileFields
     * @summary Returns profile fields
     * @request GET:/api3/profile-field
     * @response `200` `GetProfileFieldsRes`
     * @response `400` `BaseErrorResponse`
     */
    profileFieldControllerGetProfileFields = (
      query?: {
        /** @example false */
        includeDeleted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetProfileFieldsRes, BaseErrorResponse>({
        path: '/api3/profile-field',
        method: 'GET',
        query,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Profile fields
     * @name ProfileFieldControllerCreateProfileField
     * @summary Creates profile field
     * @request POST:/api3/profile-field
     * @secure
     * @response `200` `GetProfileFieldRes`
     * @response `400` `BaseErrorResponse`
     */
    profileFieldControllerCreateProfileField = (data: AddProfileFieldReq, params: RequestParams = {}) =>
      this.request<GetProfileFieldRes, BaseErrorResponse>({
        path: '/api3/profile-field',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Profile fields
     * @name ProfileFieldControllerUpdateProfileField
     * @summary Updates profile field
     * @request PUT:/api3/profile-field/{id}
     * @secure
     * @response `200` `GetProfileFieldRes`
     * @response `400` `BaseErrorResponse`
     */
    profileFieldControllerUpdateProfileField = (id: number, data: UpdateProfileFieldReq, params: RequestParams = {}) =>
      this.request<GetProfileFieldRes, BaseErrorResponse>({
        path: `/api3/profile-field/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Profile fields
     * @name ProfileFieldControllerDeleteProfileField
     * @summary Deletes profile field
     * @request DELETE:/api3/profile-field/{id}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    profileFieldControllerDeleteProfileField = (
      id: number,
      query?: {
        /**
         * Hard remove item
         * @example true
         */
        hardRemove?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/api3/profile-field/${id}`,
        method: 'DELETE',
        query,
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new ProfileField();
}
